<script setup lang="ts">
import type { PrimitiveProps } from 'reka-ui'
import type { HTMLAttributes } from 'vue'
import type { TextVariants } from '.'
import { Primitive } from 'reka-ui'
import { cn } from '@/lib/utils'
import { textVariants } from '.'

interface Props extends PrimitiveProps {
  variant?: TextVariants['variant']
  size?: TextVariants['size']
  class?: HTMLAttributes['class']
}

const props = withDefaults(defineProps<Props>(), {
  as: 'p',
  variant: 'body',
  size: 'base',
})
</script>

<template>
  <Primitive
    data-slot="text"
    :data-variant="variant"
    :data-size="size"
    :as="as"
    :as-child="asChild"
    :class="cn(textVariants({ variant, size }), props.class)"
  >
    <slot />
  </Primitive>
</template>
